import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EmailEditor from 'react-email-editor';
import { Container, Grid } from '@material-ui/core';
import { Title } from '../AdminBanner/style';
import AddCommunicated from '../Forms/AddCommunicated';
import { CommonButton } from '../common/Buttons';
import { jsPDF } from 'jspdf';

import { getEmailTemplates, getCommunicationById, createCommunication, updateCommunication, sendCommunication } from '../../actions/Communicated';
import { EmailView } from './style';

const ManageCommunicated = ({ history, match }) => {
  const dispatch = useDispatch();

  const { templates, communicatedInfo, user } = useSelector(({ communicated, auth }) => ({
    templates: communicated?.templates || [],
    communicatedInfo: communicated?.communicatedInfo || [],
    user: auth?.userData?.userLogado?.adm_login || null
  }));

  const emailEditorRef = useRef(null);
  const [formData, setFormData] = useState({});
  const [exportPdfDiv, setExportPdfDiv] = useState();

  useEffect(() => {
    dispatch(getEmailTemplates());
  }, []);

  useEffect(() => {
    if (match?.params?.id && !formData.channel) {
      dispatch(getCommunicationById(match?.params?.id)).then(() => {
        setFormData(communicatedInfo);
      });
    }
  });

  useEffect(() => {
    loadTemplate();
  }, [formData]);

  const loadTemplate = (_id = match?.params?.id) => {
    if (formData?.jsonEmail && match?.params?.edit){
      emailEditorRef.current.editor.loadDesign(formData?.jsonEmail);
      return
    }
    if (!_id) return;
    const templateSelect = templates.filter((t) => t.id === parseInt(_id));
    if (templateSelect[0]?.emailTemplate && emailEditorRef ) emailEditorRef?.current?.editor?.loadDesign(templateSelect[0]?.emailTemplate);
  };

  const exportHtml = useCallback(() => {
    emailEditorRef.current.editor.exportHtml(({ html, design }) => {
      dispatch(createCommunication({ ...formData, emailBody: html, jsonEmail: design, userWhoCreated: user }));
    });
  });

  const exportPdf = useCallback(() => {
    const doc = new jsPDF('p', 'pt', 'a4');
    emailEditorRef.current.editor.exportHtml(({ html }) => {
      setExportPdfDiv(html);
      doc.html(document.querySelector('#pdfDiv'), {
        callback: (pdf) => {
          pdf.save('emailExport.pdf');
        },
      });
    });
  });

  const sendEmail = useCallback(() => {
    dispatch(sendCommunication({ communicationId: parseInt(match?.params?.id) }));
  });

  const handleUpdate = useCallback(() => {
    emailEditorRef.current.editor.exportHtml(({ html, design }) => {
      dispatch(updateCommunication({ ...formData, id: parseInt(match?.params?.id), emailBody: html, jsonEmail: design, userWhoModified: user }));
    });
  });

  return (
    <>
      <Container>
        <Title variant="h2">Comunicado</Title>
        <AddCommunicated
          loadTemplate={loadTemplate}
          templates={templates}
          match={match?.params?.id && !match?.params?.edit ? true : false}
          formData={formData}
          setFormData={setFormData}
        />
        {match?.params?.id && !match?.params.edit ? (
          <EmailView srcDoc={formData?.emailBody} />
        ) : (
          <EmailEditor
            ref={emailEditorRef}
            onLoad={loadTemplate}
            options={{
              locale: 'pt-BR',
            }}
          />
        )}
        <Grid container justify={'space-between'} style={{ marginTop: 15 }}>
          <Grid item xs={2}>
            <CommonButton action={() => history.push('/admin/gestao_de_Comunicados')} label={'Voltar'} />
          </Grid>
          {match?.params?.id && match?.params?.edit && (
            <Grid item xs={2}>
              <CommonButton action={() => exportPdf()} label={'Exportar PDF'} />
            </Grid>
          )}
          <Grid item xs={2}>
            <CommonButton
              disabled={!formData?.title || !formData?.channel || !formData?.publico}
              action={() => (match?.params?.id ? (match?.params?.edit ? handleUpdate() : sendEmail()) : exportHtml())}
              label={match?.params?.id && !match?.params?.edit ? 'Enviar' : 'Salvar'}
            />
          </Grid>
        </Grid>
      </Container>
      <div style={{ display: 'none' }}>
        <div
          id="pdfDiv"
          dangerouslySetInnerHTML={{ __html: exportPdfDiv }}
          style={{
            width: '600px',
          }}
        />
      </div>
    </>
  );
};

export default ManageCommunicated;
